import React from 'react'
import {connect} from 'react-redux'
import {filterRecords} from './filter'
import * as types from './constants'


const defaultState = {
  filtering: true
}

export const Reducer = (state = defaultState, action) => {
  switch (action.type) {
  case types.ACTIVE_FILTER_CHANGED:
    return Object.assign(
      {},
      state,
      {filtering: action.filtering}
    )
  default:
    return state
  }
}

export const ActiveFilter = ({records, filterOn, children, filtering = true}) => {
  const filteredRecords = filterRecords(records || [], filtering, filterOn)

  return React.Children.map(children, child => (
    React.cloneElement(child, {
      records: filteredRecords,
      filtering: filtering
    })
  ))
}

export const mapStateToProps = (state) => ({
  filtering: state.active_filter.filtering
})

export default connect(mapStateToProps)(ActiveFilter)


// WEBPACK FOOTER //
// ./src/ui/active-filter/container.js